import { useEffect, useState } from "react";
import styled from "styled-components";
import ParksCard from "./ParksCard";

interface Props {
  parks: any[];
}

const ParksCardLayout = ({ parks }: Props) => {
  return (
    <StyledParksCardLayout>
      <ParksCardContainer>
        {parks.map((park) => (
          <ParksCard park={park} />
        ))}
      </ParksCardContainer>
    </StyledParksCardLayout>
  );
};

const StyledParksCardLayout = styled.div`
  @media only screen and (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const ParksCardContainer = styled.div`
  padding: 1.5rem;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;
  @media only screen and (max-width: 1296px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 1rem;
  }
  @media only screen and (max-width: 768px) {
    padding: 0;
    gap: 0.5rem;
    grid-template-columns: repeat(2, 1fr);
    justify-items:center;
  }
  @media only screen and (max-width: 526px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export default ParksCardLayout;
